import { REQUEST_ACTIVITY_TYPES, RECEIVE_ACTIVITY_TYPES, ACTIVITY_TYPES_FAIL } from 'actions/ActionTypes.js';

/** @typedef {import('./activityTypesTypeDefinitions').ActivityTypeDTO} ActivityTypeDTO */
/** @typedef {import('reducers/multiSportEdit/types/entity/RootState').RootState} RootState */

const INITIAL_STATE = {
    isFetching: false,
    entity: []
};

const requestActivityTypes = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveActivityTypes = (state, action) => {
    return {
        ...state,
        isFetching: false,
        entity: action.activityTypes,
        lastUpdated: action.receivedAt
    };
};

const activityTypesFail = (state) => {
    return {
        ...state,
        isFetching: false
    };
};

const handlers = {
    [REQUEST_ACTIVITY_TYPES]: requestActivityTypes,
    [RECEIVE_ACTIVITY_TYPES]: receiveActivityTypes,
    [ACTIVITY_TYPES_FAIL]: activityTypesFail
};

/**
 * @param {RootState} state
 * @returns {ActivityTypeDTO[]}
 */
export const getActivityTypes = (state) => state.activityTypes.entity;

export const isActivityTypesFetching = (state) => state.activityTypes.isFetching;

export default function activityTypes(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
